import type { FaireProductEntity } from "../../entity_types/product";

export const p_btcfk94xtj: FaireProductEntity = {
  token: "p_btcfk94xtj",
  type: "product",
  name: "RAW Materials - Witch Hazel Distillate - Alcohol Free",
  brandToken: "b_b3ffvix4",
  brandName: "Taylor's Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/3b175841d30c64b995bd3c6b7a15ee42c54dce3516d81c8a1dc08a7322f9c07e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4331767bf0ac048a15fbcc05547f42a180db96b33004880c836af124b0474d7c.jpeg",
    "https://cdn.faire.com/fastly/59440afa37c5a21f5879ad2b3abe5d0aef14686f9858b029bd642d5f619a04ba.jpeg",
  ],
  priceDollars: 7.8,
  description:
    "Our witch hazel is not only FREE and CLEAR of fragrances, but is also FREE of alcohol, making it a highly desirable Witch Hazel that has extended uses far beyond witch hazels that contain fragrance and alcohol.\n\nWitch Hazel is a Natural astringent; giving it the ability to remove excess oil from skin and shrink down pores. It helps to fade bruises and blemishes. It helps to brighten around the eyes, helping those unwanted dark eye circles to go away! \n\n Helps to treat varicose veins, reducing the associated pain and swelling. Aids in Hemorrhoid pain and discomfort. Helps to stop bleeding with cuts and scrapes. Perfect for aftershave / wax. \n\nStored in 8 oz Amber Glass\nBULK:  Galllon Plastic Bag (Recyclable, Reusable, Closed Loop)\n64 oz Glass Gug w/Pump, 64 oz Plastic Bag (Recyclable, Reusable, Closed Loop)",
  tags: [],
  msrpDollars: 13.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:33.074Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
